import * as yup from 'yup'

export const OverridesSchema = yup.object().shape({
  name: yup.string().required('Please enter a override name.'),
  customExceptionTypeName: yup
    .string()
    .required('Please choose a override type.'),
  appliesFromTimeHour: yup.number().nullable(true),
  appliesFromTimeMinute: yup.number().nullable(true),
  appliesToTimeHour: yup.number().nullable(true),
  appliesToTimeMinute: yup.number().nullable(true),
  appliesOnDay: yup.string(),
})
